import Cookies from 'js-cookie';

const ellipsis = (text, size) => {
    return `${text.split(' ').slice(0, size).join(' ')}...`;
};

export { ellipsis };

export const handleLogout = () => {
    // Remove authentication tokens or cookies
    Cookies.remove('SangLoggedIn');
    Cookies.remove('SangLoggedData');
    // Redirect to the login page
    window.location.href = '/';
};


export const base64ToFile = (base64, filename = 'handwriting.png') => {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}
